import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';
import { ConfigService } from 'src/app/service/config.service';
import { yukka, dev } from './hierarchy';

/**
* This is the treemap of the cockpit/news/market route
*/
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-news-board',
  templateUrl: './news-board.component.html',
  styleUrls: ['./news-board.component.scss']
})
export class NewsBoardComponent {

  /**
  * url parameters
  */
  params: any;

  /**
  * menu hierarchies
  */
  hierarchies: any = [];

  /**
  * query parameters subscribe and select the hierarchies
  */
  constructor(
    private route: ActivatedRoute,
    public routing: RoutingService,
    public config: ConfigService,
  ) {
    this.hierarchies = yukka;
    if (this.config.appConfig.environment === 'dev') { this.hierarchies = dev; }
    this.route.queryParams.subscribe(params => {
      this.params = params;
    });
  }
}
